__turbopack_context__.v({
  "iconGroup": "styles-module__BRqBVG__iconGroup",
  "iconGroupList": "styles-module__BRqBVG__iconGroupList",
  "nav": "styles-module__BRqBVG__nav",
  "navigationButtons": "styles-module__BRqBVG__navigationButtons",
  "navigationButtons--loggedIn": "styles-module__BRqBVG__navigationButtons--loggedIn",
});
